import FormSharedValuesActions from './constants';
import { IActionObject, IErrorValues } from './types';

// action creators

// Sets form state for an array of fieldKey, fieldValue
export function setSharedValueState(data: IErrorValues): IActionObject {
  return { type: FormSharedValuesActions.SET_VALUE_STATE, data };
}

// Clears form state
export function resetSharedValueState(): IActionObject {
  return { type: FormSharedValuesActions.RESET_VALUES_STATE };
}
try {
    // @ts-ignore
    setSharedValueState.displayName = "setSharedValueState";
    // @ts-ignore
    setSharedValueState.__docgenInfo = { "description": "", "displayName": "setSharedValueState", "props": { "fieldValues": { "defaultValue": null, "description": "", "name": "fieldValues", "required": true, "type": { "name": "IFieldValue[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/formSharedValues/actions.tsx#setSharedValueState"] = { docgenInfo: setSharedValueState.__docgenInfo, name: "setSharedValueState", path: "src/store/formSharedValues/actions.tsx#setSharedValueState" };
}
catch (__react_docgen_typescript_loader_error) { }